/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, isDevMode, ErrorHandler, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BatchUploaderComponent } from './batch-uploader/batch-uploader.component';
import { LibraryComponent } from './library/library.component';
import { SingleImageViewComponent } from './single-image-view/single-image-view.component';
import { ThumbnailComponent } from './thumbnail/thumbnail.component';
import { StarbaseLoginModule, WebApiService, StarbaseLoginService } from 'starbase-login';
import { StarbaseNotificationModule, StarbaseNotificationService } from 'starbase-notification';
import { LoginWrapperComponent } from './login-wrapper/login-wrapper.component';
import { RecentThumbnailsComponent } from './recent-thumbnails/recent-thumbnails.component';
import { MouseRaiserDirective } from './directives/mouse-raiser.directive';
import { StarbaseMenuBarModule } from 'starbase-menu-bar';
import { StarbaseModalDialogModule } from 'starbase-modal-dialog';
import { StarbaseModalOverlayModule } from 'modal-overlay';
import { LassoSelectDirective } from './directives/lasso-select.directive';
// import { StarbaseHelpDeskModule } from 'starbase-help-desk';
import { GatewayComponent } from './gateway-component/gateway.component';
import { KeywordsDisplayComponent } from './keywords-display/keywords-display.component';
import { EditHistoryDisplayComponent } from './edit-history-display/edit-history-display.component';
import { UnitsDisplayComponent } from './units-display/units-display.component';
import { DatesDisplayComponent } from './dates-display/dates-display.component';
import { WeaponsDisplayComponent } from './weapons-display/weapons-display.component';
import { QmManualsDisplayComponent } from './qmmanuals-display/qmmanuals-display.component';
import { QmCategoriesDisplayComponent } from './qmcategories-display/qmcategories-display.component';
import { IndividualsDisplayComponent } from './individuals-display/individuals-display.component';
import { StarbaseTableEditorModule } from 'table-editor';
import { LookupTableWrapperComponent } from './lookup-table-wrapper/lookup-table-wrapper.component';
import { ArmyToRegionalPipe } from './pipes/army-to-regional.pipe';
import { SidebarFilterComponent } from './sidebar-filter/sidebar-filter.component';
import { UnitPickerComponent } from './unit-picker/unit-picker.component';
import { UnitFilterComponent } from './unit-filter/unit-filter.component';
import { IndividualsEntryComponent } from './individuals-entry/individuals-entry.component';
import { BatchEditFormComponent } from './batch-edit-form/batch-edit-form.component';
import { FilterPipe } from './pipes/filter.pipe';
import { environment } from '../environments/environment';
import { AppInsightsService } from './app-insights.service';
import { AppInsightsErrorHandlerService } from './app-insights-error-handler.service';
import { MouseOverShowDirective } from './directives/mouse-over-show.directive';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { SearchComponent } from './search/search.component';
import { QuartermasterManualComponent } from './quartermaster-manuals/quartermaster-manuals.component';
import { SourceCallNoFilterComponent } from './source-call-no-filter/source-call-no-filter.component';
import { SourceCallNoBoxComponent } from './source-call-no-box/source-call-no-box.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DateFilterComponent } from './date-filter/date-filter.component';
import { MatSelectModule } from '@angular/material/select';
import { RankCatToRankPipe } from './pipes/rank-cat-to-rank.pipe';
import { WeaponCatToWeaponPipe } from './pipes/weapon-cat-to-weapon.pipe';
import { LibrarySearchComponent } from './library-search/library-search.component';
import { EmboldenPipe } from './pipes/embolden.pipe';
import { ImageTypeGroupPipe, ImageTypeToBatchPipe } from './pipes/image-type-to-batch.pipe';
import { LibraryFilterComponent } from './library-filter/library-filter.component';
import { SlantButtonComponent } from './slant-button/slant-button.component';
import { QmSearchComponent } from './qm-search/qm-search.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccountManagementModule } from 'account-management';
import { ContactDashModule, ContactDashComponent } from 'contact-dash';
import { DashboardModule } from 'starbase-dashboard';
import { AdminDashboardComponent } from './contact/admin-dashboard.component';
import { StarbaseLauncherModule } from 'starbase-launcher';
import { MatDividerModule } from '@angular/material/divider';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { NewTableEditorModule } from 'new-table-editor';
import { LogScreenComponent } from './log-screen/log-screen.component';
import { LogSearchComponent } from './log-search/log-search.component';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { StarbaseWizardModule } from 'starbase-wizard';
import { SquarePaymentFormComponent } from './square-payment-form/square-payment-form.component';
import { UserDataService } from './services/user-data.service';
import { QMDropdownComponent } from './qm-dropdown/qm-dropdown.component';
import { ColorCircleModule } from 'ngx-color/circle';
import { SquareManagePaymentComponent } from './square-manage-payment/square-manage-payment.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TransactionDashComponent, TransactionDashModule } from 'transaction-dash';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SiteFooterComponent } from './site-footer/site-footer.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask'
import { SortablejsModule } from 'ngx-sortablejs';
import { ContactDataService } from './services/contact-dash.service';
import { ContactUsFormModule } from 'contact-us-form';
import { CreateSbUserWrapperComponent } from './create-sb-user-wrapper/create-sb-user-wrapper.component';
import { CreateContactWizardWrapperComponent } from './create-contact-wizard-wrapper/create-contact-wizard-wrapper.component';
import { KeywordBadgeComponent } from './keyword-badge/keyword-badge.component';
import { tooltipFactory } from './app-globals.service';
import { SignUpComponent } from './sign-up/sign-up.component';
import { PlanChoicesComponent } from './plan-choices/plan-choices.component';
import { ImageCarouselComponent } from './image-carousel/image-carousel.component';
import { BattleDisplayComponent } from './battle-display/battle-display.component';
import { KeywordSearchComponent } from './keyword-search/keyword-search.component';
import { BattleSearchComponent } from './battle-search/battle-search.component';
import { LibSelectButtonComponent } from './lib-select-button/lib-select-button.component';
import { ImageNamePipe } from './models/imageFile';
import { ResizeDirective } from './resize.directive';
import { FortisManagePaymentComponent } from './fortis-manage-payment/fortis-manage-payment.component';
import { FortisPaymentFormComponent } from './fortis-payment-form/fortis-payment-form.component';
import { IndividualsSearchComponent } from './individuals-search/individuals-search.component';
import { AttributionComponent } from './attribution/attribution.component';
import { AccessibilityComponent } from './accessibility/accessibility.component';
import { AboutComponent } from './about/about.component';
import { TakedownComponent } from './takedown/takedown.component';
import { LoaderAndroidComponent, LoaderIOSComponent, PullToRefreshComponent } from './pull-to-refresh/pull-to-refresh.component';
import { SynonymsEditorComponent } from './synonyms-editor/synonyms-editor.component';
import { ImageCarouselHolderComponent } from './image-carousel-holder/image-carousel-holder.component';
import { BatchEditPaneComponent } from './batch-edit-pane/batch-edit-pane.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RecaptchaModule } from 'ng-recaptcha';
import { CallnumberSearchComponent } from './callnumber-search/callnumber-search.component';
// import { SquarePaymentFormComponent } from './square-payment-form/square-payment-form.component';

export const WebApiServiceFactory = (loginSvc: StarbaseLoginService) => {
  if (isDevMode()) {
    return new WebApiService(loginSvc, AppModule.DEV_API_SERVER_ADDRESS);
  } else {
    return new WebApiService(loginSvc, AppModule.PROD_API_SERVER_ADDRESS);
  }
};
export const LoginServiceFactory = () => new StarbaseLoginService(AppModule.LOGIN_SERVICE_TIMEOUT);

export const ContactsStarbaseDataServiceFactory = (http: HttpClient, WebApiSvc: WebApiService) => new ContactDataService(http, WebApiSvc);

export const UserDataServiceFactory = (http: HttpClient, WebApiSvc: WebApiService) =>  new UserDataService(http, WebApiSvc);


@NgModule({
    declarations: [
        AppComponent,
        LibraryComponent,
        ThumbnailComponent,
        BatchUploaderComponent,
        SingleImageViewComponent,
        LoginWrapperComponent,
        RecentThumbnailsComponent,
        MouseRaiserDirective,
        MouseOverShowDirective,
        GatewayComponent,
        KeywordsDisplayComponent,
        EditHistoryDisplayComponent,
        UnitsDisplayComponent,
        QmManualsDisplayComponent,
        DatesDisplayComponent,
        WeaponsDisplayComponent,
        IndividualsDisplayComponent,
        LookupTableWrapperComponent,
        ArmyToRegionalPipe,
        SidebarFilterComponent,
        UnitPickerComponent,
        UnitFilterComponent,
        IndividualsEntryComponent,
        BatchEditFormComponent,
        FilterPipe,
        SearchComponent,
        QuartermasterManualComponent,
        SourceCallNoFilterComponent,
        SourceCallNoBoxComponent,
        DateFilterComponent,
        RankCatToRankPipe,
        WeaponCatToWeaponPipe,
        QmCategoriesDisplayComponent,
        ImageTypeToBatchPipe,
        ImageTypeGroupPipe,
        LibraryFilterComponent,
        LibrarySearchComponent,
        EmboldenPipe,
        SlantButtonComponent,
        QmSearchComponent,
        AdminDashboardComponent,
        LogScreenComponent,
        LogSearchComponent,
        SquarePaymentFormComponent,
        QMDropdownComponent,
        SquareManagePaymentComponent,
        SiteFooterComponent,
        CreateSbUserWrapperComponent,
        CreateContactWizardWrapperComponent,
        KeywordBadgeComponent,
        SignUpComponent,
        PlanChoicesComponent,
        ImageCarouselComponent,
        KeywordSearchComponent,
        BattleDisplayComponent,
        BattleSearchComponent,
        LibSelectButtonComponent,
        ImageNamePipe,
        ResizeDirective,
        FortisManagePaymentComponent,
        FortisPaymentFormComponent,
        IndividualsSearchComponent,
        AttributionComponent,
        AccessibilityComponent,
        AboutComponent,
        TakedownComponent,
        PullToRefreshComponent,
        LoaderAndroidComponent,
        LoaderIOSComponent,
        SynonymsEditorComponent,
        ImageCarouselHolderComponent,
        BatchEditPaneComponent,
        CallnumberSearchComponent,
        LassoSelectDirective
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        MatSelectModule,
        CommonModule,
        MatDividerModule,
        ButtonsModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,
        StarbaseLoginModule,
        StarbaseNotificationModule,
        StarbaseMenuBarModule,
        StarbaseModalDialogModule,
        StarbaseModalOverlayModule,
        StarbaseTableEditorModule,
        StarbaseLauncherModule,
        StarbaseWizardModule,
        // StarbaseHelpDeskModule,
        NgbTypeaheadModule,
        RichTextEditorAllModule,
        ScrollingModule,
        TabsModule.forRoot(),
        AccountManagementModule,
        ContactDashModule,
        TransactionDashModule,
        DashboardModule,
        MatTooltipModule,
        NewTableEditorModule,
        PopoverModule.forRoot(),
        StarbaseWizardModule,
        ColorCircleModule,
        CollapseModule.forRoot(),
        BsDatepickerModule.forRoot(),
        MatSliderModule,
        // NgxMaskModule.forRoot(),
        NgxMaskDirective,
        NgxMaskPipe,
        SortablejsModule.forRoot({ animation: 150 }),
        ContactUsFormModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        RecaptchaModule
    ],
    // entryComponents was removed as it's no longer needed with Ivy
    providers: [
        AppInsightsService,
        provideNgxMask(),
        {
            provide: ErrorHandler,
            useClass: AppInsightsErrorHandlerService
        },
        {
            provide: StarbaseLoginService,
            useFactory: LoginServiceFactory,
            deps: []
        },
        {
            provide: WebApiService,
            useFactory: WebApiServiceFactory,
            deps: [StarbaseLoginService]
        },
        StarbaseNotificationService,
        HttpClient,
        {
            provide: ContactDataService,
            useFactory: ContactsStarbaseDataServiceFactory,
            deps: [HttpClient, WebApiService]
        },
        {
            provide: UserDataService,
            useFactory: UserDataServiceFactory,
            deps: [HttpClient, WebApiService]
        },
        {
            provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
            useValue: tooltipFactory
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

  public static readonly DEV_API_SERVER_ADDRESS = (environment.testMode) ?
   environment.TESTING_API_SERVER_ADDRESS :
   environment.PROD_API_SERVER_ADDRESS;
  public static readonly PROD_API_SERVER_ADDRESS = (environment.testMode) ?
    environment.TESTING_API_SERVER_ADDRESS :
    environment.PROD_API_SERVER_ADDRESS;
  public static readonly UPLOADER_SERVER_ADDRESS = (environment.testMode) ?
      environment.TESTING_UPLOADER_VM_API_SERVER_ADDRESS :
      environment.PROD_UPLOADER_VM_API_SERVER_ADDRESS;

  public static LOGIN_SERVICE_TIMEOUT = 30000; // ms

}
